import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import authService from '../../services/authService';
import Form from '../form/Form';
import SliderAuth from '../utils/SliderAuth'
import './Login.css'

const Login = () => {
  const [error, setError] = useState(null);
  const { login } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('register'); // Estado para controlar pestañas

  const initialValues = {
    email: '',
    psw: '',
  };

  const inputsConfig = [
    { label: 'Correo Electrónico', id: 'email', name: 'email', type: 'email', className: 'w-full px-4 py-2 border rounded-md focus:outline-none focus:border-bottom-blue-500', required: true },
    { label: 'Contraseña', id: 'psw', name: 'psw', type: 'password', className: 'w-full px-4 py-2 border rounded-md focus:outline-none focus:border-blue-500', required: true },
  ];

  const handleSubmit = async (formData) => {
    const { email, psw } = formData;

    try {
      const response = await authService.login(email, psw);
      const token = response.access;
      const id_user = response.id_user;

      if (token) {
        login(token, id_user);
        navigate('/home');
      } else {
        setError('Login failed. Token not found.');
      }
    } catch (err) {
      setError(err.message);
    }
  };

  const handleError = (err) => {
    setError(err);
  };

  return (
    <>
        <div className="flex justify-center items-center min-h-screen bg-gray-100">
          <div className="flex w-[800px] flex-col lg:flex-row">

            <SliderAuth/>
            <div className="w-full lg:w-3/5 p-8 mb-3 bg-white shadow-lg rounded-xl mt-3">
              <div className="flex justify-center mb-4">
                <button className="text-blue-500 font-semibold mx-1 border-b-2 border-blue-500 text-sm">INGRESAR</button>
                <Link to="/user-register" className="text-decoration-none text-gray-500 font-semibold mx-1 text-sm">
                  REGISTRARSE
                </Link>
              </div>
              <Form
                initialValues={initialValues}
                inputsConfig={inputsConfig}
                onSubmit={handleSubmit}
                handleError={handleError}
              />
              <div className="checkbox-field">
                <input
                  type="checkbox"
                  id="termsCheck"
                  required
                />
                <label htmlFor="termsCheck" className='mx-2 form-label text-sm text-blue-500 font-semibold'>
                  Recordar contraseña
                </label>
              </div>
              <div className="checkbox-field">
                <Link to="/send-reset-password" className="text-decoration-none form-label text-sm text-blue-500 font-semibold">
                  Restablecer contraseña
                </Link>
              </div>

              {error && <p className="text-red-500 mt-2">{error}</p>}

            </div>
          </div>
        </div>
    </>

  );
};

export default Login;